<template>
    <div>
          <div class="row justify-content-center">
            <div class="col">

              
          <upload-image :makecircle="circle" :inputId="inputId" ref="upload" :image="mini_profile_image" @newImageSrc="update_input_from_upload" editbutton="true" @editingImage="hideChooseButton" @stopEditingImage="showChooseButton" :uploadButtonText="uploadButtonLabel"></upload-image>
            

            </div>
          </div>

          <div class="text-center">
            <b-button v-if="enableLibraryButton" v-show="libraryButton" v-b-modal="medialib_modal_id">{{ libraryButtonLabel }}</b-button>

            <b-modal :id="medialib_modal_id" title="Media Library" size="xl" :hide-footer="true">
              <sd-media-manager defaultTab="" prefix="/sd-media/" @selectedImageFromLibrary="update_input_from_lib"></sd-media-manager>
            </b-modal>

          </div>

          <input :ref="input_name" type="hidden" :name="input_name" :id="hidden_input_id" :value="mini_profile_image">

    </div>
</template>

<script>
    export default {
        mounted() {

      
        },
        props: [
            'image',
            'inputId',
            'name',
            'disableLibraryButton',
            'libraryButtonText',
            'uploadButtonText',
            'makecircle',
        ],
        data: function(){

            return {
                mini_profile_image: this.image,
                input_name: this.name,
                hidden_input_id: this.inputId+'_hidden',
                medialib_modal_id: this.inputId+'_modal',
                libraryButton: true,
                circle: this.makecircle,
                enableLibraryButton: !this.disableLibraryButton,
                libraryButtonLabel: this.libraryButtonText ? this.libraryButtonText : 'Choose From Library',
                uploadButtonLabel: this.uploadButtonText ? this.uploadButtonText : 'Upload Image'
            }
        },

        methods: {
          update_input_from_lib: function(background){

            this.mini_profile_image =  background.src;
            this.$refs[this.input_name].value = background.src;          
            this.$emit('change', background.src);
            this.$bvModal.hide(this.medialib_modal_id);
          },
          update_input_from_upload: function(background){
            this.mini_profile_image =  background.src;
            this.$emit('change', background.src);
            this.$bvModal.hide(this.medialib_modal_id);
          },
          hideChooseButton: function(){
            this.libraryButton = false;
          },
          showChooseButton: function(){
            this.libraryButton = true;
          }
      }
    }
</script>



